<template>
  <slot />

  <SafeTeleport to=".tooltip-warp-zone" v-if="isVisible">
    <transition appear name="slide-fade-in">
      <div v-if="text && isVisible" class="pointer-events-none hidden md:block">
        <div
          class="tooltip-arrow absolute bg-navy-deep rounded-sm h-3 w-3"
          :class="[positionClass]"
          :style="arrowStyle"
        ></div>
        <div
          ref="overlayElement"
          class="tooltip absolute bg-navy-deep text-white text-sm rounded-md py-1 px-3"
          :class="[positionClass]"
          :style="style"
        >
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="truncate max-w-xs" v-html="text"></div>
        </div>
      </div>
    </transition>
  </SafeTeleport>
</template>

<script lang="ts" setup>
import { useOverlayApi, type Position } from '../overlay'
import { SafeTeleport } from 'vue-safe-teleport'

const { text, position = 'bottom' } = defineProps<{
  text?: string
  position?: Position
}>()

const { overlayElement, isVisible, arrowStyle, style, positionClass } =
  useOverlayApi(text ?? 'empty-tooltip', { position })
</script>

<style scoped lang="scss">
.slide-fade-in-enter-active {
  opacity: 1;
  transition: opacity 150ms 400ms ease-in-out;
  > * {
    margin: 0;
    transition: margin 100ms 400ms ease-in-out;
  }
}

.slide-fade-in-enter-from,
.slide-fade-in-leave-to {
  opacity: 0 !important;

  > * {
    &.p-top {
      margin-top: 0.5rem;
    }
    &.p-bottom {
      margin-top: -0.5rem;
    }
    &.p-left {
      margin-left: 0.5rem;
    }
    &.p-right {
      margin-left: -0.5rem;
    }
  }
}
</style>
